import React from "react";
import { FaHandsHelping, FaUsers, FaCertificate, FaHeart } from "react-icons/fa";
import './WhyJoin.css'

const WhyJoin = () => {
  const benefits = [
    { icon: <FaHandsHelping />, title: "Serve Devotees", text: "Assist devotees during Divya Darshan & spiritual programs." },
    { icon: <FaUsers />, title: "Community Service", text: "Join local seva like food, blood, and health camps." },
    { icon: <FaCertificate />, title: "Digital Certificate", text: "Receive a  membership certificate." },
    { icon: <FaHeart />, title: "Pure Devotion", text: "Serve with love and humility under divine guidance." },
  ];

  return (
    <section id="why-join">
      <div className="why-join-container">
        <h2 className="why-join-title">Why Join Us?</h2>
        <div className="why-join-grid">
          {benefits.map((b) => (
            <div key={b.title} className="why-join-card">
              <div className="why-join-icon">{b.icon}</div>
              <h3 className="why-join-card-title">{b.title}</h3>
              <p className="why-join-card-text">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyJoin;
